import { useMutation } from '@tanstack/react-query'

import { CriarAtendimentoService } from '@/http/criar-atendimento.service'
import type { TCriarAtendimentoResponse } from '@/http/criar-atendimento.service'
import type { AxiosErrorMap } from '@/infra/http'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

export const useCriarAtendimento = () => {
  return useMutation<TCriarAtendimentoResponse, AxiosErrorMap, string, unknown>({
    mutationKey: atendimentoKeys.criarAtendimento(),
    mutationFn: async (clienteId: string) => new CriarAtendimentoService().execute(clienteId),
  })
}
